import { Add } from "@mui/icons-material";
import { Button } from "@mui/material";

import { ConversationCreateModal } from "../conversation-create-modal";

import { useModalStore } from "@/hooks";

export function NewConversationButton() {
  const { pushModal } = useModalStore((state) => state.actions);

  const handleNewConversation = () => {
    pushModal({
      title: "New Message",
      content: (
        <ConversationCreateModal
          modifySubmissionValues={(values) => ({
            ...values,
            to: values.to.map((id) => ({ type: "internal", account_id: id })),
            cc: values.cc.map((id) => ({ type: "internal", account_id: id })),
          })}
        />
      ),
    });
  };

  return (
    <Button color="primary" variant="contained" fullWidth startIcon={<Add />} onClick={handleNewConversation}>
      New Message
    </Button>
  );
}
